import Icon from "@/components/Icon"
import type { Nullable } from "@/models"
import { faCheck, faQuestion, faXmark } from "@fortawesome/free-solid-svg-icons"

export function getBooleanDisplayValue(value: Nullable<boolean>, nullText: string) {
	if (value === null) {
		return nullText
	} else {
		return value ? "Yes" : "No"
	}
}

export function isEmptyStringOrNull(value: Nullable<string>) {
	return value === null || value === undefined || value === ""
}

export function getIcon(value: Nullable<boolean>) {
	switch (value) {
		case true:
			return <Icon icon={faCheck} style="color: #198754" />
		case false:
			return <Icon icon={faXmark} style="color: #F00" />
		default:
			return <Icon icon={faQuestion} style="color: #696969" />
	}
}
